<template>
  <div>
    <header-component></header-component>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Basic Details</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <base-input v-model="copies" label="Number of Copies" @keyup="generateBarcode()" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <div class="grid-item" v-for="(item, index) in parseInt(copies)" :key="index">
        <svg
          class="barcode"
          jsbarcode-format="code128"
          :jsbarcode-value="barcode"
          jsbarcode-textmargin="0"
          jsbarcode-fontoptions="bold"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const JsBarcode = require("jsbarcode");

import headerComponent from "../Components/HeaderComponent";

export default {
  data() {
    return {
      copies: 32
    };
  },
  computed: {
    ...mapGetters({ barcode: "product/getBarcode" }),
  },
  components: {
    "header-component": headerComponent
  },
  mounted() {
    this.generateBarcode();
  },
  watch:{
      copies(val) {
          JsBarcode(".barcode").render()
      }
  },
  methods: {
    generateBarcode() {
      JsBarcode(".barcode").init();
    }
  }
};
</script>

<style>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  /* padding: 10px; */
  margin: 0 auto;
  width: 720px;
  overflow: hidden;
}
.grid-item {
  text-align: center;
}
.barcode {
  width: 160px;
  height: 100px;
}
</style>